import {RecordForm} from '../forms/RecordForm';


import {useSubscription} from '../hooks/useSubscription.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";


export const AddPage = () => {

    const {
        record,
        createRecord,
    } = useSubscription();

    return (
        <FormPageLayout
            title='Add Subscription'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={record || {} as any} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
